import React from 'react'
import styled from 'styled-components'
import { Gif } from '@giphy/react-components'
import { IContentBlock } from '../types'
import Label from './block-label'

const ASPECT_RATIO = 0.6

const Container = styled.a<{ isSticker: boolean }>`
    background: #212121;
    display: block;
    position: relative;

    img {
        object-fit: ${props => (props.isSticker ? 'contain' : 'cover')};
    }
`

type Props = {
    data: IContentBlock
    width: number
}

const ContentBlock = ({ data, width }: Props) => {
    const { gif, user, url, label } = data
    const height = width * ASPECT_RATIO
    return (
        <Container href={url} isSticker={gif.is_sticker} style={{ width }}>
            <Gif gif={gif} height={height} width={width} noLink hideAttribution />
            <Label label={label} user={user} />
        </Container>
    )
}

export default ContentBlock
